import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import ProProtectedRoute from "@/components/ProProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Diagnostic from "@/pages/Diagnostic";
import Results from "@/pages/Results";
import Dashboard from "@/pages/Dashboard";
import History from "@/pages/History";
import Pricing from "@/pages/Pricing";
import FAQ from "@/pages/FAQ";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Referrals from "@/pages/Referrals";
import AdminAdvertisers from "@/pages/AdminAdvertisers";
import Pro from "@/pages/Pro";
import AdminPro from "@/pages/AdminPro";
import Technicians from "@/pages/Technicians";
import TechnicianRegister from "@/pages/TechnicianRegister";
import AdminTechnicians from "@/pages/AdminTechnicians";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminBlog from "@/pages/AdminBlog";
import AdminSpaParts from "@/pages/AdminSpaParts";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAffiliate from "@/pages/AdminAffiliate";
import PartnerTubs from "@/pages/PartnerTubs";
import Installations from "@/pages/Installations";
import AdminAds from "@/pages/AdminAds";
import Manufacturers from "@/pages/Manufacturers";
import ManufacturerDetail from "@/pages/ManufacturerDetail";
import SpaParts from "@/pages/SpaParts";
import ErrorCodes from "@/pages/ErrorCodes";
import ErrorCodeDetail from "@/pages/ErrorCodeDetail";
import Tutorials from "@/pages/Tutorials";
import TutorialDetail from "@/pages/TutorialDetail";
import TutorialNew from "@/pages/TutorialNew";
import MyTutorials from "@/pages/MyTutorials";
import AdminTutorials from "@/pages/AdminTutorials";
import AdminNewsletter from "@/pages/AdminNewsletter";
import Kits from "@/pages/Kits";
import KitDetail from "@/pages/KitDetail";
import KitSuccess from "@/pages/KitSuccess";
import AdminKits from "@/pages/AdminKits";
import AdminContact from "@/pages/AdminContact";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/technicians" element={<Technicians />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/annuaire-fabricants" element={<Manufacturers />} />
            <Route path="/annuaire-fabricants/:slug" element={<ManufacturerDetail />} />
            <Route path="/pieces-detachees" element={<SpaParts />} />
            <Route path="/codes-erreurs" element={<ErrorCodes />} />
            <Route path="/codes-erreurs/:brand/:code" element={<ErrorCodeDetail />} />
            <Route path="/tutos" element={<Tutorials />} />
            <Route path="/tutos/nouveau" element={<ProtectedRoute><TutorialNew /></ProtectedRoute>} />
            <Route path="/tutos/mes-tutos" element={<ProtectedRoute><MyTutorials /></ProtectedRoute>} />
            <Route path="/tutos/:slug" element={<TutorialDetail />} />
            <Route path="/kits" element={<Kits />} />
            <Route path="/kits/success" element={<KitSuccess />} />
            <Route path="/kits/:slug" element={<KitDetail />} />
            <Route path="/partenaires/tubs" element={<PartnerTubs />} />
            <Route path="/installations" element={<Installations />} />

            <Route path="/diagnostic" element={<ProtectedRoute><Diagnostic /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
            <Route path="/results/:id" element={<ProtectedRoute><Results /></ProtectedRoute>} />
            <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
            <Route path="/pro" element={<ProProtectedRoute><Pro /></ProProtectedRoute>} />
            <Route path="/technicians/register" element={<ProtectedRoute><TechnicianRegister /></ProtectedRoute>} />
            <Route path="/admin/advertisers" element={<ProtectedRoute><AdminAdvertisers /></ProtectedRoute>} />
            <Route path="/admin/technicians" element={<ProtectedRoute><AdminTechnicians /></ProtectedRoute>} />
            <Route path="/admin/pro" element={<ProtectedRoute><AdminPro /></ProtectedRoute>} />
            <Route path="/admin/blog" element={<ProtectedRoute><AdminBlog /></ProtectedRoute>} />
            <Route path="/admin/spa-parts" element={<ProtectedRoute><AdminSpaParts /></ProtectedRoute>} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/affiliate" element={<ProtectedRoute><AdminAffiliate /></ProtectedRoute>} />
            <Route path="/admin/ads" element={<ProtectedRoute><AdminAds /></ProtectedRoute>} />
            <Route path="/admin/tutorials" element={<ProtectedRoute><AdminTutorials /></ProtectedRoute>} />
            <Route path="/admin/newsletter" element={<ProtectedRoute><AdminNewsletter /></ProtectedRoute>} />
            <Route path="/admin/kits" element={<ProtectedRoute><AdminKits /></ProtectedRoute>} />
            <Route path="/admin/contact" element={<ProtectedRoute><AdminContact /></ProtectedRoute>} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
